import AddProductManuallyButton from './AddProductManuallyButton';

export default AddProductManuallyButton;